import { configureStore } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { QuestionnaireSlice } from "./Slices/questionnaire";
import { AuthSlice } from "./Slices/auth";
import { AreaSlice } from "./Slices/area";
import { ClientSlice } from "./Slices/client";
import analyseReducer from "./Slices/analyse";

export const store = configureStore({
  reducer: {
    auth:    AuthSlice.reducer,
    questionnaire: QuestionnaireSlice.reducer,
    areas:   AreaSlice.reducer,
    analyse: analyseReducer,
    client:  ClientSlice.reducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
// this knows about thunks because configureStore adds redux-thunk by default
export type AppDispatch = typeof store.dispatch;

// now your hooks:
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
